var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSpecial = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 269,
    height: 269,
    viewBox: "0 0 269 269",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1780_3014)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1780_3014)",
    filter: "url(#filter0_dddd_1780_3014)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 514,
    height: 64,
    transform: "translate(-102.354 260.099) rotate(-45)",
    fill: "#DB4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.525 75.8944L128.372 59.7415L131.797 56.3164L145.122 69.6409L151.673 63.0892L154.502 65.9176L144.525 75.8944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.791 81.6284L133.775 78.9547L127.886 84.8436L130.56 89.8596L126.87 93.5498L116.351 71.6295L120.539 67.4421L142.481 77.9382L138.791 81.6284ZM130.085 76.8997C125.518 74.4985 122.936 73.1395 122.34 72.8228C121.75 72.4987 121.294 72.2335 120.97 72.0273C121.669 73.2131 123.305 76.2404 125.875 81.1092L130.085 76.8997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.412 99.008L105.259 82.855L108.684 79.4299L124.837 95.5829L121.412 99.008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.309 93.0417C99.0202 94.3307 98.5083 95.8149 98.7735 97.4943C99.0313 99.1663 100.026 100.868 101.757 102.599C105.358 106.201 108.511 106.65 111.214 103.947C112.348 102.812 113.439 101.155 114.485 98.9748L117.357 101.847C116.584 103.726 115.379 105.482 113.744 107.118C111.395 109.467 108.887 110.554 106.22 110.377C103.546 110.193 100.876 108.767 98.21 106.101C96.5306 104.422 95.3668 102.647 94.7187 100.776C94.0631 98.8975 93.971 97.0524 94.4424 95.2404C94.9138 93.4137 95.9193 91.7306 97.4587 90.1912C99.0276 88.6223 100.983 87.4254 103.325 86.6004L105.005 90.4895C104.114 90.8062 103.255 91.1635 102.431 91.5612C101.606 91.959 100.898 92.4525 100.309 93.0417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.601 116.818L94.2985 126.121L78.1455 109.968L87.4484 100.665L90.2547 103.471L84.3769 109.349L87.9235 112.896L93.3925 107.427L96.1988 110.233L90.7298 115.702L94.8951 119.868L100.773 113.99L103.601 116.818Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9635 128.353L76.0904 127.226C77.1437 126.173 77.7256 125.178 77.8361 124.243C77.9392 123.3 77.593 122.431 76.7975 121.635C75.9947 120.832 75.1807 120.461 74.3558 120.519C73.5382 120.571 72.6617 121.065 71.7262 122L70.1684 123.558L74.9635 128.353ZM80.1342 118.056C81.8725 119.794 82.6569 121.668 82.4875 123.679C82.3255 125.683 81.2427 127.686 79.2392 129.69L77.7698 131.159L83.515 136.904L80.09 140.329L63.937 124.177L69.0967 119.017C71.056 117.058 72.9674 115.993 74.8309 115.824C76.6944 115.64 78.4622 116.384 80.1342 118.056Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6766 138.772C74.135 140.23 74.7574 141.906 74.5438 143.799C74.3376 145.684 73.299 147.563 71.4281 149.433C69.7045 151.157 67.8557 152.358 65.8817 153.035L62.6998 149.853C64.276 149.249 65.5392 148.671 66.4894 148.119C67.4469 147.559 68.2388 146.966 68.8648 146.34C69.6161 145.589 70.047 144.87 70.1575 144.185C70.2754 143.493 70.0507 142.863 69.4836 142.296C69.1668 141.979 68.7986 141.788 68.3787 141.722C67.9515 141.648 67.4506 141.67 66.8761 141.788C66.3089 141.898 65.2483 142.23 63.6941 142.782C62.2431 143.305 61.0572 143.6 60.1365 143.666C59.2158 143.732 58.3245 143.629 57.4627 143.357C56.601 143.084 55.7907 142.569 55.0321 141.81C53.6031 140.381 52.9623 138.775 53.1096 136.993C53.2643 135.203 54.1961 133.454 55.9049 131.745C56.7446 130.905 57.6432 130.205 58.6007 129.646C59.5657 129.078 60.6447 128.559 61.838 128.088L63.3958 131.855C62.1805 132.363 61.2193 132.831 60.5121 133.258C59.8124 133.678 59.19 134.161 58.6449 134.706C57.9968 135.354 57.6506 136.002 57.6064 136.65C57.5622 137.298 57.7832 137.866 58.2693 138.352C58.5713 138.654 58.9064 138.849 59.2747 138.937C59.6356 139.018 60.0739 139.015 60.5895 138.926C61.1051 138.823 62.2063 138.473 63.893 137.877C66.1248 137.089 67.8852 136.779 69.1742 136.949C70.4558 137.111 71.6233 137.718 72.6766 138.772Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddd_1780_3014",
    x: -112.354,
    y: -105.354,
    width: 428.708,
    height: 446.708,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1780_3014"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1780_3014",
    result: "effect2_dropShadow_1780_3014"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1780_3014",
    result: "effect3_dropShadow_1780_3014"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1780_3014",
    result: "effect4_dropShadow_1780_3014"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_1780_3014",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1780_3014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 269,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1780_3014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 514,
    height: 64,
    fill: "white",
    transform: "translate(-102.354 260.099) rotate(-45)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpecial, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/special.2027a53e.svg";
export { ForwardRef as ReactComponent };